"use strict";

define('view/flag.selection.container',['require','exports','module','uikit/uikit','templates','view/table.flag'],function (require, exports, module) {
  var UIKit = require('uikit/uikit');
  var Templates = require('templates');
  var FlagTable = require('view/table.flag');
  module.exports = UIKit.Container.extend({
    attributes: {
      'aria-describedby': 'flagsDescription'
    },
    template: Templates.IRB['flag.selection.container'],
    options: {
      availableFlags: null,
      model: null
    },
    modelEvents: {
      'change:flags': '_handleChangeStudyFlags'
    },
    _handleChangeStudyFlags: function _handleChangeStudyFlags(studyModel, flags) {
      _.each(this._getContainedFlagTables(), function (flagTable) {
        flagTable.resetStudyFlags(flags);
      });
    },
    _getContainedFlagTables: function _getContainedFlagTables() {
      return _.reduce(this.tablesContainer.getChildViews(), function (flagTables, childView) {
        var tableView = childView.view;
        if (tableView instanceof FlagTable) {
          flagTables.push(tableView);
        }
        return flagTables;
      }, []);
    },
    _getAllSelectedFlags: function _getAllSelectedFlags() {
      return _.flatten(_.reduce(this._getContainedFlagTables(), function (selectedFlags, flagTable) {
        selectedFlags.push(flagTable.getSelectedFlags());
        return selectedFlags;
      }, []));
    },
    _setSaveButtonEnabled: function _setSaveButtonEnabled() {
      this.saveButton.disabled = _.every(this._getContainedFlagTables(), function (flagTable) {
        return !flagTable.isDirty();
      });
    },
    _saveChanges: function _saveChanges() {
      this.model.set('flags', this._getAllSelectedFlags());
      this.model.save();
      this._setSaveButtonEnabled();
    },
    _initSaveListeners: function _initSaveListeners() {
      _.each(this._getContainedFlagTables(), function (flagTable) {
        this.listenTo(flagTable, 'row:press', this._setSaveButtonEnabled);
      }, this);
      this.listenTo(this.saveButton, 'press', this._saveChanges);
    },
    _setSaveButtonARIAAttributes: function _setSaveButtonARIAAttributes() {
      this.saveButton.updateElementAttributes({
        'aria-controls': this.cid
      });
    },
    _initSaveButton: function _initSaveButton() {
      this._setSaveButtonARIAAttributes();
      this._initSaveListeners();
    },
    _initTables: function _initTables() {
      var studyFlags = this.model.get('flags');
      var VulnerablePopulationsFlagsTableOptions = {
        availableFlags: this.availableFlags,
        category: 'Population',
        columns: [{
          text: 'Vulnerable Populations',
          data: 'description'
        }],
        studyFlags: studyFlags
      };
      var vulnerablePopulationsFlagsTable = new FlagTable(VulnerablePopulationsFlagsTableOptions);
      var additionalFlagsTableOptions = {
        availableFlags: this.availableFlags,
        category: 'Additional',
        columns: [{
          text: 'Additional Flags',
          data: 'description'
        }],
        studyFlags: studyFlags
      };
      var additionalFlagsTable = new FlagTable(additionalFlagsTableOptions);
      this.tablesContainer.add(vulnerablePopulationsFlagsTable);
      this.tablesContainer.add(additionalFlagsTable);
      this.tablesContainer.getChildViews = function () {
        return this._views;
      };
    },
    initialize: function initialize(options) {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this._initTables();
      this._initSaveButton();
    }
  });
});

